import { createTheme } from '@mui/material/styles';
import { pxToRem } from '../utils/pxToRem';
import { breakpointValues } from './breakpoints';
import { palette } from './palette';

export const theme = createTheme({
  breakpoints: {
    values: breakpointValues,
  },
  palette: {
    primary: { main: palette.navy, contrastText: palette.white },
    secondary: { main: palette.gold, contrastText: palette.navy },
    info: { main: palette.link, contrastText: palette.white },
    background: { default: palette.white, paper: palette.surface },
    text: { primary: palette.navy, secondary: palette.navy },
    common: { white: palette.white },
  },
  typography: {
    fontFamily: '"Roboto", sans-serif',
    h1: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 400,
      fontSize: pxToRem(48),
      lineHeight: pxToRem(56),
      color: palette.navy,
    },
    h2: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 400,
      fontSize: pxToRem(32),
      lineHeight: pxToRem(40),
      color: palette.navy,
    },
    h3: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 400,
      fontSize: pxToRem(24),
      lineHeight: pxToRem(32),
      color: palette.navy,
    },
    h4: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 400,
      fontSize: pxToRem(20),
      lineHeight: pxToRem(28),
      color: palette.navy,
    },
    h5: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 400,
      fontSize: pxToRem(18),
      lineHeight: pxToRem(24),
      color: palette.navy,
    },
    h6: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 400,
      fontSize: pxToRem(16),
      lineHeight: pxToRem(22),
      color: palette.navy,
    },
    body1: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 400,
      fontSize: pxToRem(16),
      lineHeight: pxToRem(20),
      color: palette.navy,
    },
    body2: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 400,
      fontSize: pxToRem(12),
      lineHeight: pxToRem(20),
      color: palette.navy,
    },
    button: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 400,
      fontSize: pxToRem(12),
      lineHeight: pxToRem(20),
      textTransform: 'none',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          scrollBehavior: 'smooth',
          scrollPaddingTop: pxToRem(62),
          '@media (min-width: 801px)': {
            scrollPaddingTop: pxToRem(50),
          },
        },
        '@media (prefers-reduced-motion: reduce)': {
          html: { scrollBehavior: 'auto' },
          '*, *::before, *::after': {
            animationDuration: '0.01ms !important',
            animationIterationCount: '1 !important',
            transitionDuration: '0.01ms !important',
          },
        },
        body: {
          margin: 0,
          backgroundColor: palette.white,
          color: palette.navy,
          fontFamily: '"Roboto", sans-serif',
        },
        ':focus-visible': {
          outline: `2px solid ${palette.gold}`,
          outlineOffset: '2px',
        },
      },
    },
    MuiLink: {
      defaultProps: { underline: 'hover' },
    },
  },
});
